import { all, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/concreteBatches';
import callToAPI from '../../../utils/callToAPI';

function* getConcreteBatches({ payload }) {
  yield callToAPI({
    apiCall: Api.getConcreteBatches,
    successResponseCode: 200,
    errorType: types.GET_CONCRETE_BATCHES_ERROR,
    *callback({ data }) {
      yield put({
        type: types.GET_CONCRETE_BATCHES_SUCCESS,
        payload: {
          data: data.data,
          total: data.total,
        },
      });
    },
    payload,
  });
}

function* deleteConcreteBatch({ payload }) {
  yield callToAPI({
    apiCall: Api.deleteConcreteBatch,
    successResponseCode: 200,
    errorType: types.DELETE_CONCRETE_BATCH_ERROR,
    *callback() {
      yield put({
        type: types.DELETE_CONCRETE_BATCH_SUCCESS,
        payload,
      });
    },
    payload,
  });
}

function* createConcreteBatch({ payload }) {
  yield callToAPI({
    apiCall: Api.createConcreteBatch,
    successResponseCode: 201,
    errorType: types.CREATE_CONCRETE_BATCH_ERROR,
    *callback({ data }) {
      yield payload.callback(data);
      yield put({
        type: types.CREATE_CONCRETE_BATCH_SUCCESS,
        payload: data,
      });
    },
    payload: payload.concreteBatch,
  });
}

function* watcherDeleteConcreteBatch() {
  yield takeEvery(types.DELETE_CONCRETE_BATCH_REQUEST, deleteConcreteBatch);
}

function* watcherGetConcreteBatches() {
  yield takeLatest(types.GET_CONCRETE_BATCHES_REQUEST, getConcreteBatches);
}

function* watcherCreateConcreteBatch() {
  yield takeEvery(types.CREATE_CONCRETE_BATCH_REQUEST, createConcreteBatch);
}

export default function* rootSaga() {
  yield all([
    fork(watcherGetConcreteBatches),
    fork(watcherDeleteConcreteBatch),
    fork(watcherCreateConcreteBatch),
  ]);
}
